import * as Yup from 'yup';
import { BREED_PEDIGREE_TYPES, ENERGY_LEVELS, SHEDDING_LEVELS } from '../../../utils/constants';

// eslint-disable-next-line import/prefer-default-export
export const BreedValidation = Yup.object().shape({
  name: Yup
    .string()
    .nullable()
    .required('Name is required.')
    .max(80, 'Max 80 chars.'),
  size: Yup.array().of(Yup.string()).min(1, 'You must select at least 1 size.'),
  colors: Yup.array().of(Yup.number()).min(1, 'You must enter at least 1 color.'),
  description: Yup
    .string()
    .transform((_, original) => original.replace(/(<([^>]+)>)/gi, ''))
    .max(2000, 'Descriptions can be no more than 2000 characters in length.')
    .nullable(),
  breed_grouping_id: Yup
    .number()
    .typeError('Breed group is required.')
    .required('Breed group is required.'),
  breed_categories: Yup
    .array()
    .of(Yup.number()),
  slug: Yup
    .string()
    .nullable()
    .max(80, 'Max 80 chars.')
    .matches(
      /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
      {
        message: 'Slugs must match the alpha-dash pattern.',
        excludeEmptyString: true,
      },
    ),
  pedigree: Yup
    .string()
    .required()
    .oneOf(Object.values(BREED_PEDIGREE_TYPES)),
  hypoallergenic: Yup.boolean().required(),
  coat_type: Yup.array().of(Yup.string()),
  temperament_guide: Yup
    .string()
    .transform((_, original) => original.replace(/(<([^>]+)>)/gi, ''))
    .max(2000, 'Temperament Guide can be no more than 2000 characters in length.')
    .nullable(),
  energy_level: Yup
    .string()
    .nullable()
    .oneOf([...Object.values(ENERGY_LEVELS), null]),
  energy_level_guide: Yup
    .string()
    .transform((_, original) => original.replace(/(<([^>]+)>)/gi, ''))
    .max(2000, 'Activity Level Guide can be no more than 2000 characters in length.')
    .nullable(),
  shedding: Yup
    .string()
    .nullable()
    .oneOf([...Object.values(SHEDDING_LEVELS), null]),
  health_guide: Yup
    .string()
    .transform((_, original) => original.replace(/(<([^>]+)>)/gi, ''))
    .max(2000, 'Health Guide can be no more than 2000 characters in length.')
    .nullable(),
  size_description: Yup
    .string()
    .nullable()
    .max(250, 'Max 250 chars.'),
  lifespan: Yup
    .string()
    .nullable()
    .max(250, 'Max 250 chars.'),
  appearance_guide: Yup
    .string()
    .transform((_, original) => original.replace(/(<([^>]+)>)/gi, ''))
    .max(2000, 'Appearance can be no more than 2000 characters in length.')
    .nullable(),
  grooming_guide: Yup
    .string()
    .transform((_, original) => original.replace(/(<([^>]+)>)/gi, ''))
    .max(2000, 'Grooming Guide can be no more than 2000 characters in length.')
    .nullable(),
  shedding_guide: Yup
    .string()
    .transform((_, original) => original.replace(/(<([^>]+)>)/gi, ''))
    .max(2000, 'Shedding Guide can be no more than 2000 characters in length.')
    .nullable(),
  alternative_breed_names: Yup.array().of(Yup.string()),
  subtitle: Yup
    .string()
    .nullable()
    .max(250, 'Max 250 chars.'),
  guide_title: Yup
    .string()
    .nullable()
    .max(250, 'Max 250 chars.'),
  guide_subtitle: Yup
    .string()
    .nullable()
    .max(250, 'Max 250 chars.'),
  history: Yup
    .string()
    .transform((_, original) => original.replace(/(<([^>]+)>)/gi, ''))
    .max(2000, 'History can be no more than 2000 characters in length.')
    .nullable(),
  coat_length: Yup.array().of(Yup.string()),
  parent_a_id: Yup.number().nullable(),
  parent_b_id: Yup.number().nullable(),
  super_id: Yup.number().nullable(),
  usable: Yup.boolean(),
  legacy_id: Yup.number().nullable(),
  faq: Yup.array().of(Yup.object().shape({
    question: Yup.string().max(255, 'Question can be no more than 255 characters in length').nullable(),
    answer: Yup.string().max(1000, 'Answer can be no more than 1000 characters in length').nullable(),
  }).test('question-answer', 'Either question or answer must be provided, or both must be empty.', function (value, context) {
    const { question, answer } = value;
    if ((question && !answer)) {
      return this.createError({ path: `${context.path}.answer`, message: 'Both question and answer must be provided if one is present.' });
    }
    if ((!question && answer)) {
      return this.createError({ path: `${context.path}.question`, message: 'Both question and answer must be provided if one is present.' });
    }
    return true;
  })),
});
